var map = {
	"./en/app.json": "./resources/js/locales/en/app.json",
	"./en/panel.json": "./resources/js/locales/en/panel.json",
	"./en/plan.json": "./resources/js/locales/en/plan.json",
	"./en/user.json": "./resources/js/locales/en/user.json",
	"./ja/account.json": "./resources/js/locales/ja/account.json",
	"./ja/account_block.json": "./resources/js/locales/ja/account_block.json",
	"./ja/admin_corporation.json": "./resources/js/locales/ja/admin_corporation.json",
	"./ja/admin_job_applicant.json": "./resources/js/locales/ja/admin_job_applicant.json",
	"./ja/admin_offer.json": "./resources/js/locales/ja/admin_offer.json",
	"./ja/app.json": "./resources/js/locales/ja/app.json",
	"./ja/apply-job.json": "./resources/js/locales/ja/apply-job.json",
	"./ja/corporation_info.json": "./resources/js/locales/ja/corporation_info.json",
	"./ja/invoice.json": "./resources/js/locales/ja/invoice.json",
	"./ja/login.json": "./resources/js/locales/ja/login.json",
	"./ja/member.json": "./resources/js/locales/ja/member.json",
	"./ja/panel.json": "./resources/js/locales/ja/panel.json",
	"./ja/payment-agency.json": "./resources/js/locales/ja/payment-agency.json",
	"./ja/payment.json": "./resources/js/locales/ja/payment.json",
	"./ja/registration.json": "./resources/js/locales/ja/registration.json",
	"./ja/reset_password.json": "./resources/js/locales/ja/reset_password.json",
	"./ja/setting.json": "./resources/js/locales/ja/setting.json",
	"./ja/user.json": "./resources/js/locales/ja/user.json",
	"./ja/validation.json": "./resources/js/locales/ja/validation.json",
	"./ja/withdrawal.json": "./resources/js/locales/ja/withdrawal.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./resources/js/locales sync recursive [A-Za-z0-9-_,\\s]+\\.json$/";